import { apiService, API_ENDPOINTS } from '../config/api';
import type { SupportRequestPayload } from '../types';

export class SupportService {
  static async submitSupportRequest(
    data: SupportRequestPayload
  ): Promise<{ success: boolean; message: string }> {
    return apiService.post(API_ENDPOINTS.SUPPORT.SUBMIT, data);
  }
}
